import React, { useEffect, useState } from "react";
import { Metadata } from "../../../Utilities/Metadata";
import { useLocation } from "react-router-dom";

const PrivacyPolicy = () => {
  const [policyBody, setPolicyBody] = useState();

  const location = useLocation();

  const fetchPolicy = async () => {
    let url = `https://public-api.wordpress.com/rest/v1.1/sites/blocksfinance.wordpress.com/posts/?category=the-blocks/tb-legal/tb-privacy-policy`;

    await fetch(url)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then((data) => {
        setPolicyBody(data.posts[0]);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (!policyBody) {
      fetchPolicy();
    }
  }, []);

  let metadata = {
    title: `The Blocks Privacy Policy`,
    image: "",
    description: "Privacy policies are available for our various resources.",
    url: `https://theblocks.finance${location.pathname}`,
  };

  return (
    <div className="privacy-policy twelvefiftycontent">
      {Metadata(metadata)}
      <h1 className="page-title">Privacy Policy</h1>

      <section className="policy-container">
        <img
          alt="icon for displayed privacy policy"
          src={policyBody?.featured_image}
        />
        <h2>{policyBody?.title}</h2>
        <div
          className="policy-body"
          dangerouslySetInnerHTML={{ __html: policyBody?.content }}
        ></div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
